import { useState } from 'react';
import { Box, Link, Typography, Button, Modal, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import BoxDefaultContent from '../components/box/BoxDefaultContent';
import BoxSectionTeam from '../components/box/BoxSectionTeam';
import BreakpointUtils from '../utils/BreakpointUtils';
import SponsorSegment from '../components/SponsorSegment';

interface ImageProps {
  src: string;
  name: string;
  homepage?: string;
}

function AboutPageImage(props: ImageProps) {

  const imgStyle = {
    borderRadius: '50%',
    width: BreakpointUtils.lessThanSmall() ? '150px' : '200px',
    height: BreakpointUtils.lessThanSmall() ? '150px' : '200px',
    margin: '.5rem',
    border: '1px solid rgb(45, 45, 45)'
  }

  if (props.homepage === undefined) {
    return (
      <Box sx={{ textAlign: 'center' }}>
        <img src={props.src} style={imgStyle} />
        <Typography>{props.name}</Typography>
        <Typography>University of Tübingen</Typography>
      </Box>
    )
  }

  return (
    <Box sx={{
      textAlign: 'center',
    }}>
      <Link color='secondary' href={props.homepage} target='_blank'>
        <img src={props.src} style={imgStyle} />
        <Typography>{props.name}</Typography>
        <Typography>University of Tübingen</Typography>
      </Link>
    </Box>
  )
}

function AboutShopingCardImage(props: ImageProps) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const imgStyle = {
    width: BreakpointUtils.lessThanSmall() ? '150px' : '200px',
    height: BreakpointUtils.lessThanSmall() ? '150px' : '200px',
    margin: '.5rem',
  }

  return (
   <Box sx={{ textAlign: 'center' }}>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='modal-title'
        aria-describedby='modal-description'
      >
        <Box sx={{ 
          position: 'absolute', 
          top: '50%', 
          left: '50%', 
          transform: 'translate(-50%, -50%)', 
          width: 400, 
          bgcolor: 'background.paper', 
          border: '2px solid #000', 
          boxShadow: 24, 
          p: 4 
        }}>
          <IconButton
            aria-label='close'
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <Typography id='modal-title' variant='h6' component='h2' sx={{ textAlign: 'center' }}>
            Only for premium users.
          </Typography>
        </Box>
      </Modal>
      <img src={props.src} style={imgStyle} />
      <Typography>{props.name}</Typography>
      <Button
          sx={{ height: '40px', margin: '5px 0 5px 0' }}
          variant='outlined'
          color='secondary'
          onClick={handleOpen}>
          Buy Now!
        </Button>
    </Box>
  )
}

function AboutPageTeamImage(props: ImageProps) {

  const imgStyle = {
    width: BreakpointUtils.lessThanSmall() ? '90%' : '100%',
    height: BreakpointUtils.lessThanSmall() ? '90%' : '100%',
    margin: '.5rem',
    border: '2px solid #000'
  }

  if (props.homepage === undefined) {
    return (
      <Box sx={{
        textAlign: 'center',
      }}>
        <img src={props.src} style={imgStyle} />
      </Box>
    )
  }

}

export default function AboutPage() {
  return (
    <BoxDefaultContent sx={{ maxWidth: '900px' }}>

      <Typography sx={{ mt: 2 }}>
        If you have any feedback, bug reports or feature requests please send them to
        <a href="mailto:scholar-inbox@googlegroups.com"> scholar-inbox@googlegroups.com</a>
      </Typography>
      <BoxSectionTeam heading={'Scholar Inbox Team'} sx={{ mt: 2, }}>
        <AboutPageImage src="image/team/andreas.jpg" name="Andreas Geiger" homepage="https://cvlibs.net/about" />
      </BoxSectionTeam>

      <BoxSectionTeam sx={{ mt: 2, }}>
        <AboutPageImage src="image/team/markus.jpg" name="Markus Flicke" />
        <AboutPageImage src="image/team/vitalii__200x200.jpg" name="Vitalii Protsenko" />
        <AboutPageImage src="image/team/madhav.jpg" name="Madhav Iyengar" />
        <AboutPageImage src="image/team/haoyu.jpg" name="Haoyu He" />
        <AboutPageImage src="image/team/jovan.jpg" name="Jovan Cicvaric" />
        <AboutPageImage src="image/team/lewin.jpg" name="Lewin Scholz" />
        <AboutPageImage src="image/team/kavy.jpg" name="Kavyanjali Agnihotri" />
        <AboutPageImage src="image/team/lukas.jpg" name="Lukas Schuler" />
      </BoxSectionTeam>

      <BoxSectionTeam sx={{ mt: 2, }}>
        <AboutPageImage src="image/team/illja.jpg" name="Illia Shakun" />
        <AboutPageImage src="image/team/bora.jpeg" name="Bora Kargi" />
      </BoxSectionTeam>

      <BoxSectionTeam heading={'Scholar Inbox Ambassadors'} sx={{ mt: 5, }}>
        <AboutPageTeamImage src="image/team/ambassadors.jpg" name="Our Ambassadors" />
      </BoxSectionTeam>

      <BoxSectionTeam heading={'Scholar Inbox Fashion & Fan Shop'} sx={{ mt: 2, }}>
        <AboutShopingCardImage src="image/shop/si_merch_black.jpg" name="T-Shirt Black" />
        <AboutShopingCardImage src="image/shop/si_merch_orange.jpg" name="T-Shirt Orange" />
        <AboutShopingCardImage src="image/shop/eink_reader.png" name="Scholar Inbox eInk Reader" />
      </BoxSectionTeam>

      <SponsorSegment sx={{ my: 2, pb: 2 }} />

    </BoxDefaultContent>
  )
}